export const MESSAGE_EVENT_ENDPOINT = '/chat/message/event';
export const SLIDER_SAVE_ENDPOINT = '/user/slider/save';
export const FAVORITE_ENDPOINT = '/user/favorite/add?id=:id';


export interface MessageEvent{
    id: number;
    notificationType: string;
    isClicked: number;
    isOpened: number;
}

export interface SliderSaveEvent{
    userId: number;
    aboutUserId: number;
    attitude: number;
}

import { api } from './fetch';
import { apiRequestDeduplicator } from '../utils/debounce';

export const Post = (endpoint: string, data: MessageEvent | SliderSaveEvent) => {
    // Create a unique key for request deduplication
    const requestKey = `${endpoint}-${JSON.stringify(data)}`;
    
    return apiRequestDeduplicator.deduplicate(requestKey, () =>
        api.post(endpoint, data)
    );
};